<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link :to="{ name: 'TicketList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <button
            class="btn btn-danger"
            @click="deleteItem(item)">Delete</button>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <div class="card-header">
              <b-row class="mb-3">
              <h4 class="card-title">{{item.title}}</h4>
              </b-row>
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <p><b>{{$t('views.ticket.show.internalData')}}:</b> {{ item['internalData']}}</p>
                  <p><b>{{$t('views.ticket.show.sentToIam')}}:</b> {{ item['sentToIam'] }}</p>
                  <p><b>{{$t('views.ticket.show.state')}}:</b> {{ item['state'] }}</p>
                  <p><b>{{$t('views.ticket.show.createdAt')}}:</b> {{ item['createdAt'] }}</p>
                  <p><b>{{$t('views.ticket.show.updatedAt')}}:</b> {{ item['updatedAt'] }}</p>
                  <p><b>{{$t('views.ticket.show.deletedBy')}}:</b> {{ item['deletedBy'] }}</p>
                  <p><b>{{$t('views.ticket.show.message')}}:</b> {{ item['message'] }}</p>
                  <p><b>{{$t('views.ticket.show.priority')}}:</b> {{ item['priority'] }}</p>
                  <p><b>{{$t('views.ticket.show.status')}}:</b> {{ item['status'] }}</p>
                  <p><b>{{$t('views.ticket.show.idTicketFromApplication')}}:</b> {{ item['idTicketFromApplication'] }}</p>
                  <p><b>{{$t('views.ticket.show.application')}}:</b> {{ item.application.subdomain}}.{{ item.application.domain.domain}}</p>
                  <div v-if="item.documents"><b>{{$t('views.ticket.show.documents')}}:</b> <p v-for="i in item.documents" :key="i.fileName" > {{i.fileName}}</p></div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
<!--      <b-row v-if="item">-->
<!--        <b-col>-->
<!--          <b-tabs v-model="tabIndex" content-class="mt-3">-->
<!--            <b-tab :title="$t('views.firm.show.userDataEmployees')">-->
<!--              <b-card>-->
<!--                  <template v-if="item.length > 0">-->
<!--                    <b-row v-for="(userDataEmployee, userDataEmployeeIndex) in item.userDataEmployees" v-bind:key="'userDataEmployee-' + userDataEmployeeIndex">-->
<!--                      <b-col>-->
<!--                        <p>-->
<!--                          <b>{{$t('views.firm.show.userDataEmployee.nameAndSurname')}}:</b> {{ userDataEmployee.employee['name'] }} {{ userDataEmployee.employee['surname'] }}<br>-->
<!--                          <b>{{$t('views.firm.show.userDataEmployee.userEmail')}}:</b> {{ userDataEmployee.employee['userEmail'] }}<br>-->
<!--                          <b>{{$t('views.firm.show.userDataEmployee.mobilePhone')}}:</b> {{ userDataEmployee.employee['mobilePhone'] }}<br>-->
<!--                          <b>{{$t('views.firm.show.userDataEmployee.isContactPerson')}}:</b> <span v-if="userDataEmployee['isContactPerson'] === 1">{{ $t('buttons.yes') }}</span><span v-else>{{ $t('buttons.no') }}</span>-->
<!--                        </p>-->
<!--                      </b-col>-->
<!--                      <b-col cols="4" lg="4">-->
<!--                        <b-row v-if="ableToEditFirm">-->
<!--                          <b-col>-->
<!--                            <div class="float-right">-->
<!--                              <b-btn variant="warning" @click="editEmployee(userDataEmployee)" class="btn-sm m-0 mt-1 mr-1">{{ $t('buttons.edit') }}</b-btn>-->
<!--                              &lt;!&ndash;<b-btn variant="danger" @click="deleteItem(userDataEmployee)" class="btn-sm m-0 mt-1">{{ $t('buttons.delete') }}</b-btn>&ndash;&gt;-->
<!--                            </div>-->
<!--                          </b-col>-->
<!--                        </b-row>-->
<!--                      </b-col>-->
<!--                    </b-row>-->
<!--                  </template>-->
<!--          </b-card>-->
<!--        </b-col>-->
<!--      </b-row>-->
    </b-col>
  </b-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'

export default {
  components: { Loader },
  computed: mapGetters({
    deleteError: 'ticket/del/error',
    error: 'ticket/show/error',
    isLoading: 'ticket/show/isLoading',
    item: 'ticket/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'ticket/del/del',
      reset: 'ticket/show/reset',
      retrieve: 'ticket/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'TicketList' }))
      }
    }
  }
}
</script>
